<template>
  <header
    :class="DS_PAGE_HEADER_CLASSES.Root"
    data-cy="ds-page-header"
  >
    <div
      :class="DS_PAGE_HEADER_CLASSES.Title"
      data-cy="ds-page-header__title"
    >
      <slot />
    </div>
    <div
      v-if="slots.actions"
      :class="DS_PAGE_HEADER_CLASSES.Actions"
      data-cy="ds-page-header__actions"
    >
      <slot name="actions" />
    </div>
  </header>
</template>

<script setup lang="ts">
import { useSlots } from "vue";
import { DS_PAGE_HEADER_CLASSES } from "../constants/classes";

const slots = useSlots();
</script>
